export default function ServiceGrid() {
  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Emergency Mobile Repair',
      description: 'Fast response for critical breakdowns. We repair heavy equipment, trailers, structural components, and machinery on-site to minimize your downtime.',
      features: [
        'Heavy Equipment Welding',
        'Trailer & Frame Repair',
        'Structural Emergency Fixes',
        'On-Site Diagnostics'
      ],
      image: 'https://public.readdy.ai/ai/img_res/59fba63ef83febe540e2ac60aee5468d.jpg'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Custom Fabrication',
      description: 'Precision metalwork tailored to your specifications. From decorative gates to heavy-duty brackets, we build it right the first time.',
      features: [
        'Custom Gates & Railings',
        'Specialty Brackets & Mounts',
        'Architectural Metalwork',
        'Prototype Development'
      ],
      image: 'https://readdy.ai/api/search-image?query=Custom%20metal%20fabrication%20workshop%20with%20ornate%20iron%20gate%20and%20decorative%20railings%20being%20crafted%20precision%20metalwork%20tools%20and%20equipment%20clean%20industrial%20workspace%20professional%20craftsmanship%20detailed%20metalwork&width=600&height=400&seq=service-002&orientation=landscape'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial & Industrial',
      description: 'Comprehensive welding solutions for businesses and facilities. Pipe welding, structural maintenance, and ongoing site support.',
      features: [
        'Pipe Welding',
        'Facility Maintenance',
        'Structural Modifications',
        'Contract Services Available'
      ],
      image: 'https://readdy.ai/api/search-image?query=Industrial%20pipe%20welding%20in%20commercial%20facility%20large%20diameter%20steel%20pipes%20being%20welded%20professional%20welder%20in%20protective%20gear%20industrial%20plant%20background%20commercial%20welding%20operation%20safety%20equipment%20visible&width=600&height=400&seq=service-003&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-orange-500">Welding Services</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professional mobile welding and fabrication services delivered with precision and reliability
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* Service Image */}
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-orange-500 rounded-lg">
                    <i className={`${service.icon} text-3xl text-white`}></i>
                  </div>
                </div>
              </div>

              {/* Service Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Features List */}
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                        <i className="ri-check-line text-lg text-orange-500"></i>
                      </div>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Need a custom solution?</p>
          <button
            onClick={() => document.querySelector<HTMLButtonElement>('#sticky-cta-btn')?.click()}
            className="whitespace-nowrap bg-gray-900 hover:bg-orange-500 text-white font-bold text-base px-8 py-4 rounded-lg transition-all duration-300 cursor-pointer"
          >
            Discuss Your Project
          </button>
        </div>
      </div>
    </section>
  );
}
